// extracted by mini-css-extract-plugin
export var chevronIcon = "_s3-1";
export var edgeToggle = "_s3-0";